// src/admin/components/PostSeoPanel.jsx

import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { useTheme } from "../../context/ThemeContext";
import ImageUploader from "./ImageUploader";

export default function PostSeoPanel({
    formData,
    updateField,
    onOgImageChange,
    ogImagePreview,
}) {

    const { isDark } = useTheme();

    const [searchExpanded, setSearchExpanded] = useState(true);
    const [ogExpanded, setOgExpanded] = useState(false);

    const inputClass = `
        w-full
        px-4
        py-3
        rounded-xl
        border
        outline-none
        transition-all
        ${
            isDark
                ? "bg-white/5 border-white/10 focus:border-blue-800/50"
                : "bg-white border-gray-300 focus:border-blue-800"
        }
    `;

    const cardClass = `
        rounded-3xl
        border
        p-6
        ${
            isDark
                ? "bg-white/5 border-white/10"
                : "bg-white border-gray-200"
        }
    `;

    return (

        <div className="space-y-6">

            <h2 className="text-2xl font-semibold">
                SEO Settings
            </h2>

            {/* Search Engine SEO */}

            <div className={cardClass}>

                <button
                    type="button"
                    onClick={() => setSearchExpanded(!searchExpanded)}
                    className="w-full flex items-center justify-between"
                >

                    <div className="text-left">

                        <h3 className="text-lg font-semibold">
                            Search Engine SEO
                        </h3>

                        <p className="text-sm opacity-70 mt-1">
                            Optimize how this article appears in Google search results.
                        </p>

                    </div>

                    {searchExpanded
                        ? <ChevronDown size={20}/>
                        : <ChevronRight size={20}/>
                    }

                </button>

                {searchExpanded && (

                    <div className="space-y-5 mt-8">

                        <input
                            value={formData.meta_title}
                            onChange={(e) =>
                                updateField("meta_title", e.target.value)
                            }
                            className={inputClass}
                            placeholder="Meta Title"
                        />

                        <textarea
                            rows={4}
                            value={formData.meta_description}
                            onChange={(e) =>
                                updateField("meta_description", e.target.value)
                            }
                            className={inputClass}
                            placeholder="Meta Description"
                        />

                        <input
                            value={formData.keywords}
                            onChange={(e) =>
                                updateField("keywords", e.target.value)
                            }
                            className={inputClass}
                            placeholder="Keywords (comma separated)"
                        />

                        <input
                            value={formData.canonical_url}
                            onChange={(e) =>
                                updateField("canonical_url", e.target.value)
                            }
                            className={inputClass}
                            placeholder="Canonical URL"
                        />

                    </div>

                )}

            </div>

            {/* Open Graph */}

            <div className={cardClass}>

                <button
                    type="button"
                    onClick={() => setOgExpanded(!ogExpanded)}
                    className="w-full flex items-center justify-between"
                >

                    <div className="text-left">

                        <h3 className="text-lg font-semibold">
                            Social Sharing (Open Graph)
                        </h3>

                        <p className="text-sm opacity-70 mt-1">
                            Control how this article appears when shared on Facebook, LinkedIn, WhatsApp and X.
                        </p>

                    </div>

                    {ogExpanded
                        ? <ChevronDown size={20}/>
                        : <ChevronRight size={20}/>
                    }

                </button>

                {ogExpanded && (

                    <div className="space-y-5 mt-8">

                        <input
                            value={formData.og_title}
                            onChange={(e) =>
                                updateField("og_title", e.target.value)
                            }
                            className={inputClass}
                            placeholder="Open Graph Title"
                        />

                        <textarea
                            rows={4}
                            value={formData.og_description}
                            onChange={(e) =>
                                updateField("og_description", e.target.value)
                            }
                            className={inputClass}
                            placeholder="Open Graph Description"
                        />

                        <ImageUploader
                            title="Open Graph Image"
                            description="Recommended size: 1200 × 630px"
                            preview={ogImagePreview}
                            onChange={onOgImageChange}
                        />

                    </div>

                )}

            </div>

        </div>

    );

}